<template>
  <div id="title">
    <header>
      <h1>{{title}}</h1>
    </header>
  </div>
</template>

<script>
export default {
    props:['title']
};
</script>

<style lang="less" scoped>
#title {
  header {
    padding-top: 94px;
    padding-bottom: 93px;
    h1 {
      font-family: PingFang-SC-Heavy;
      font-size: 52px;
      color: #283349;
    }
  }
}
</style>
